export default {"src":"/_next/static/media/location-pin.3d742e79.svg","height":72,"width":72};